import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSocialMedia } from "../../redux/slices/socialMediaSlice";
import './SocialIcons.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { TbBrandWhatsappFilled } from "react-icons/tb";

const SocialIcons = () => {
  const dispatch = useDispatch();
  const { links, isLoading } = useSelector((state) => state.socialMedia);

  useEffect(() => {
    dispatch(fetchSocialMedia());
  }, [dispatch]);

  if (isLoading || !links) return null;

  return (
    <div className="social_icons mt-4">
      {links.facebook && (
        <a href={links.facebook} target="_blank" rel="noopener noreferrer" className="link">
          <FaFacebookF />
        </a>
      )}
      {links.insta && (
        <a href={links.insta} target="_blank" rel="noopener noreferrer" className="link">
          <FaInstagram />
        </a>
      )}
      {links.whats && (
        <a href={links.whats} target="_blank" rel="noopener noreferrer" className="link">
          <TbBrandWhatsappFilled />
        </a>
      )}
      {links.linked_in && (
        <a href={links.linked_in} target="_blank" rel="noopener noreferrer" className="link">
          <FaLinkedinIn />
        </a>
      )}
      {links.youtube && (
        <a href={links.youtube} target="_blank" rel="noopener noreferrer" className="link">
          <FaYoutube />
        </a>
      )}
    </div>
  );
};

export default SocialIcons;
